module.exports = __webpack_public_path__ + "img/drop-down-red.179e9377.svg";